import * as React from "react";
const SvgCellOpen = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 1.871V22.13H22.13V1.87H12ZM3.38 3.38H20.62V20.62H3.38V12Zm7.873 3.935V11.252H7.314v1.496H11.252v3.938h1.496l.004-1.967.002-1.965 1.965-.002 1.967-.004v-1.496H12.748V7.314H12Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgCellOpen;
